/** Mobil oynatıcı dokunma yardımcıları. */

export const DOUBLE_TAP_MS = 300;
export const SINGLE_TAP_DELAY_MS = 260;

export type SeekDirection = 'back' | 'forward';

/** Dokunulan nokta ekranın sol yarısında mı? */
export function seekDirectionForTap(clientX: number, left: number, width: number): SeekDirection {
  return clientX - left < width / 2 ? 'back' : 'forward';
}

/** İki dokunma aynı kısa aralıkta mı? */
export function isDoubleTap(
  previousAt: number | null,
  now: number,
  thresholdMs = DOUBLE_TAP_MS,
): boolean {
  return previousAt !== null && now - previousAt <= thresholdMs;
}
